import { render, staticRenderFns } from "./aiCWAnalysis.vue?vue&type=template&id=256c5a39&scoped=true"
import script from "./aiCWAnalysis.vue?vue&type=script&lang=js"
export * from "./aiCWAnalysis.vue?vue&type=script&lang=js"
import style0 from "./aiCWAnalysis.vue?vue&type=style&index=0&id=256c5a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c5a39",
  null
  
)

export default component.exports